import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackUpdatedPeopleSort.meta';

export type UseTrackUpdatedPeopleSortParams = {
  sort_field: string;
  sort_direction: string;
};

export const useTrackUpdatedPeopleSort = () => {
  const { track } = useAnalyticsUtilities();

  const trackUpdatedPeopleSort = useCallback(
    (params: UseTrackUpdatedPeopleSortParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUpdatedPeopleSort };
};
